<template>
    <div class="min_box">
        <div class="title">基本信息</div>
        <div class="sec1">
            <div class="flex">
                <p :title="basic_info.domain"><span>域名：</span>{{basic_info.domain}}</p>
                <p :title="basic_info.contact_person" ><span>联系人：</span>{{basic_info.contact_person}}</p>
                <p :title="basic_info.version_name"><span>合同版本：</span>{{basic_info.version_name}}</p>
                <p :title="basic_info.server_name"><span>服务器：</span>{{basic_info.server_name}}</p>
                <p :title="basic_info.langset_name"><span>主语种：</span>{{basic_info.langset_name}}</p>
                <p :title="basic_info.small_langset_name"><span>小语种：</span>{{basic_info.small_langset_name}}</p>
                <p :title="basic_info.lang_num"><span>语种数量：</span>{{basic_info.lang_num}}</p>
                <p :title="basic_info.industry_name"><span>行业：</span>{{basic_info.industry_name}}</p>
                <p :title="basic_info.main_products"><span>主营产品：</span>{{basic_info.main_products}}</p>
                <p :title="basic_info.contact_person"><span>用户名：</span>{{basic_info.nickname}}</p>
                <p :title="basic_info.email"><span>邮箱：</span>{{basic_info.email}}</p>
                <p :title="basic_info.mobile"><span>手机号：</span>{{basic_info.mobile}}</p>
                <p :title="basic_info.mobile"><span>网站类型：</span>{{basic_info.site_type_name}}</p>
            </div>
        </div>
        <div class="sec2 flex">
            <Card class="item" :data="dataa">
                <!--                <slot> <img src="../../../../assets/logo.png" alt="" class="logo"></slot>-->
            </Card>

            <Card class="item" :data="datab">
                <!--                <slot> <img src="../../../../assets/logo.png" alt="" class="logo"></slot>-->
            </Card>
        </div>
        <div class="sec2 flex">
            <Card class="item" :data="datac">
                <!--                <slot> <img src="../../../../assets/logo.png" alt="" class="logo"></slot>-->
            </Card>

            <Card class="item" :data="datad">
                <!--                <slot> <img src="../../../../assets/logo.png" alt="" class="logo"></slot>-->
            </Card>
        </div>
        <div class="sec2 flex">
            <Card class="item" :data="datae">
                <!--                <slot> <img src="../../../../assets/logo.png" alt="" class="logo"></slot>-->
            </Card>
            <Card class="item" :data="dataf">
                <!--                <slot> <img src="../../../../assets/logo.png" alt="" class="logo"></slot>-->
            </Card>
        </div>
        <div class="sec2 flex">
            <Card class="item" :data="datag">
                <!--                <slot> <img src="../../../../assets/logo.png" alt="" class="logo"></slot>-->
            </Card>
        </div>
        <div class="sec3">
            <div class="title">访客信息</div>
            <a-table :columns="columns" :data-source="data" rowKey="ids" :pagination="false">
                <span slot="pv_total_sum" slot-scope="text, record"> {{text==null?0:text}} </span>
                <span slot="uv_total_sum" slot-scope="text, record"> {{text==null?0:text}} </span>
            </a-table>
        </div>
    </div>
</template>

<script>
    import Card from "../../components/card"
    import API from "../api";

    const columns = [
        {
            dataIndex: 'type',
            key: 'type',
            title: '统计时间',
            scopedSlots: {customRender: "type"}
        },
        {
            title: '浏览量（PV）',
            dataIndex: 'pv_total_sum',
            key: 'pv_total_sum',
            scopedSlots: {customRender: "pv_total_sum"}
        },
        {
            title: '访客量（UV）',
            dataIndex: 'uv_total_sum',
            key: 'uv_total_sum',
            scopedSlots: {customRender: "uv_total_sum"}
        },
        {
            title: '询盘量',
            key: 'inquiry_num_count',
            dataIndex: 'inquiry_num_count',
        },
        {
            title: '产品数',
            key: 'product_num_count',
            dataIndex: 'product_num_count',
        },
        {
            title: '新闻数',
            key: 'news_num_count',
            dataIndex: 'news_num_count',
        },

    ];
    export default {
        name: "webDetails",
        data() {
            return {
                data: [],
                dataa: [],
                datab: [],
                datac: [],
                datad: [],
                datae: [],
                dataf: [],
                datag: [],
                columns,
                id: this.$route.query.id,
                basic_info: []
            }
        },
        created() {
            this.$store.state.adminleftnavnum = "/DataStatistics/WebStatistics"; //设置左侧导航2-2 active
        },
        methods: {
            getDetail() {
                API.service.WEB_GET_LIST(this.id).then(res => {
                    this.basic_info = res.data.data.basic_info
                    this.data = res.data.data.visitor_info
                    this.data.map((item, index) => {
                        item.ids=index
                        if (item.type == 1) item.type = "全部"
                        if (item.type == 2) item.type = "本月"
                        if (item.type == 3) item.type = "上月"
                    })
                    this.dataa = [
                        {value: res.data.data.basic_info.online_time, title: "上线日期"},
                        {value: res.data.data.basic_info.expire_time, title: "到期日期"},
                        {
                            value: this.DateDiff2(res.data.data.basic_info.expire_time, res.data.data.basic_info.expire_time) ,
                            title: "剩余天数"
                        }
                    ]

                    this.datab = [
                        {value: res.data.data.basic_info.translation_set_num, title: "翻译购买字符数"},
                        {value: res.data.data.basic_info.translation_use_num, title: "使用量"},
                        {
                            value: res.data.data.basic_info.translation_set_num - res.data.data.basic_info.translation_use_num,
                            title: "剩余量"
                        }
                    ]

                    this.datac = [
                        {value: res.data.data.basic_info.fb_num, title: "FB查询总数"},
                        {value: res.data.data.basic_info.fb_use_num, title: "使用数"},
                        {
                            value: res.data.data.basic_info.fb_surplus_num,
                            title: "剩余数"
                        }
                    ]
                    this.datad = [
                        {value: res.data.data.basic_info.linkedin_num, title: "linkedin查询总数"},
                        {value: res.data.data.basic_info.linkedin_use_num, title: "使用数"},
                        {
                            value: res.data.data.basic_info.linkedin_surplus_num,
                            title: "剩余数"
                        }
                    ]
                    this.datae = [
                        {value: res.data.data.basic_info.keyword_num, title: "关键词总数"},
                        {value: res.data.data.basic_info.keyword_use_num, title: "使用数"},
                        {
                            value: res.data.data.basic_info.keyword_surplus_num,
                            title: "剩余数"
                        }
                    ]
                    this.dataf = [
                        {value: res.data.data.basic_info.google_map_num, title: "google查询总数"},
                        {value: res.data.data.basic_info.google_map_use_num, title: "使用数"},
                        {
                            value: res.data.data.basic_info.google_map_surplus_num,
                            title: "剩余数"
                        }
                    ]
                    this.datag = [
                        {value: res.data.data.basic_info.search_engine_num, title: "搜索引擎查询总数"},
                        {value: res.data.data.basic_info.search_engine_use_num, title: "使用数"},
                        {
                            value: res.data.data.basic_info.search_engine__surplus_num,
                            title: "剩余数"
                        }
                    ]
                })
            },
            DateDiff2(sDate1, sDate2) { //sDate1和sDate2是"12/18/2011"格式
                var oDate1, oDate2, iDays;
                oDate1 = new Date();
                oDate2 = new Date(sDate2);

                var iDays = parseInt(Math.abs(oDate1 - oDate2) / 1000 / 60 / 60 / 24);
                if ((oDate2 - oDate1) < 0) {
                    // return -iDays;
                    return 0;
                }
                if(iDays.toString()=="NaN")iDays="--"
                return iDays;
            }
        },
        mounted() {
            this.getDetail()
        },
        components: {Card}
    }
</script>

<style scoped>
    .title {
        font-weight: bold;
        font-size: 20px;
        margin-bottom: 20px
    }

    .sec1 p {
        display: inline-block;
        width: 48%
    }
    .sec1 p{height: 25px;overflow: hidden;margin-bottom: 10px;}
    .sec1 p span {
        display: inline-block;
        width: 75px;
        text-align: right;
        margin-right: 10px
    }

    .logo {
        width: 25%;
        display: inline-block
    }

    .sec2 {
        margin: 0 auto;
        margin-top: 20px;
        width: 98%;
    }

    .sec2 .item {
        width: 48%
    }

    .sec3 {
        margin-top: 20px
    }
    .min_box{width: 70%}
    >>>.ant-table-thead .ant-table-column-title{font-weight: bold;}
</style>
